import React, { Fragment } from 'react';
import InnerHTML from 'dangerously-set-inner-html'
import { processHtml } from '../utils/htmlProcessor';

function Htmlcontent(props) {
    // console.log('html content =',props)
    return (
        <Fragment>
            <InnerHTML html={processHtml(props.data)} />
        </Fragment>


    );
}

export default Htmlcontent;
